module.exports = __webpack_public_path__ + "static/media/LCC_DE.d83688c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/LCC_DE.png
// module id = 1505
// module chunks = 0